module.exports = __webpack_public_path__ + "img/DSC_0019.3b34510e.jpg";